import type { NpvrNotificationState } from '@norlys-a-s/norlys-play-kmm';

import { NpvrNotificationStateInfo } from '@smart-tv/typings/npvr';

import { kmm } from './kmm';

const mapNpvrNotificationState = (state: NpvrNotificationState): NpvrNotificationStateInfo => ({
  dotExpiringSoonEventsShown: state.dotExpiringSoonEventsShown,
  dialogExpiringSoonEventsShown: state.dialogExpiringSoonEventsShown,
  dotScheduledEventsShown: state.dotScheduledEventsShown,
  dialogScheduledEventsShown: state.dialogScheduledEventsShown,
  dotFailedEventsShown: state.dotFailedEventsShown,
  dialogFailedEventsShown: state.dialogFailedEventsShown,
  dotGlobalShown: state.dotGlobalShown,
  dialogGlobalShown: state.dialogGlobalShown
});

export async function getNpvrNotificationState(): Promise<NpvrNotificationStateInfo> {
  const state = await kmm((repo) => repo.getNpvrNotifications(), false);

  return mapNpvrNotificationState(state);
}

export default getNpvrNotificationState;
